import { SYMBOL_INFO_CACHE_VERSION, SYMBOL_INFO_STORAGE_KEY } from './market-data.constants';
import { isCachedSymbolInfo } from './market-data.utils';
import { CachedSymbolInfo, SymbolInfo } from './market-data.model';

/**
 * The cached `symbolinfo` list, or `null` when there is none worth reading. A cache that
 * fails validation — another version, a hand-edited value, a half-written entry — is removed
 * so it is not parsed again on every start.
 */
export function readStoredSymbolInfo(): SymbolInfo[] | null {
	try {
		const stored = localStorage.getItem(SYMBOL_INFO_STORAGE_KEY);
		if (stored === null) {
			return null;
		}

		const parsed: unknown = JSON.parse(stored);
		if (isCachedSymbolInfo(parsed)) {
			return parsed.data;
		}

		localStorage.removeItem(SYMBOL_INFO_STORAGE_KEY);
		return null;
	} catch {
		return null;
	}
}

/** Only ever called with a list that came through `parseSymbolInfoList`. */
export function writeStoredSymbolInfo(data: readonly SymbolInfo[], now: Date): void {
	const entry: CachedSymbolInfo = { version: SYMBOL_INFO_CACHE_VERSION, savedAt: now.toISOString(), data: [...data] };

	try {
		localStorage.setItem(SYMBOL_INFO_STORAGE_KEY, JSON.stringify(entry));
	} catch {
		// Storage full or blocked: the fresh list is already in memory, it just won't survive a restart.
	}
}
